import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Footer from './Components/Common/Footer'
import Header from './Components/Common/Header'
import Landingpage from './Components/Landingpage'
import Services from './Components/Pages/Services'
import Servicesdetail from './Components/Pages/servicedetail'
import Aboutus from './Components/Pages/Aboutus'
import BlogArchive from './Components/Pages/blogArchive'
import BlogSingle from './Components/Pages/blogsingle'
import Contact from './Components/Pages/Contact'
import Webdesign from './Components/services/servicess/webdesign'
import WebDevelopment from './Components/services/servicess/webdevelp'
import CrmSoftware from './Components/services/servicess/crmsoft'
import MobileAppDevelopment from './Components/services/servicess/mobileapp'
import CrossPlatformSoftware from './Components/services/servicess/crossplatform'
import UiUxDesign from './Components/services/servicess/ui-ux'
import SoftwareTesting from './Components/services/servicess/softwaretest'
import SecurityTesting from './Components/services/servicess/securitytest'
import BlockchainDevelopment from './Components/services/Latest/Blockchain'
import AiMlDevelopment from './Components/services/Latest/Aiml'
import DataAnalytics from './Components/services/Latest/DataAnalytics'
import DataScience from './Components/services/Latest/Datascience'
import RoboticProcessAutomation from './Components/services/Latest/Robatics'
import IoTDevelopment from './Components/services/Latest/iot'
import CloudComputing from './Components/services/Latest/CloudComputing'
import DigitalMarketing from './Components/services/Latest/DigitalMarketing'
import NativeAppDevelopment from './Components/services/servicess/nativeapp'
import Portfolio from './Components/Pages/Portfolio'
import Faq from './Components/Pages/Faq'
import Career from './Components/Pages/Career'
import Team from './Components/Pages/Team'
import LegalNoties from './Components/Pages/LegalNoties'




const App = () => {

  return (
    <div className="site-wrapper">
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Landingpage />} />
          <Route path='/Services' element={<Services />} />
          <Route path='/service-detail' element={<Servicesdetail />} />
          <Route path='/about' element={<Aboutus />} />
          <Route path='/Portfolio' element={<Portfolio />} />
          <Route path='/blog-archive' element={<BlogArchive />} />
          <Route path='/blog-single' element={<BlogSingle />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/Faq' element={<Faq />} />
          <Route path='/career' element={<Career />} />
          <Route path='/Team' element={<Team />} />
          <Route path='/legal-noties' element={<LegalNoties />} />

          {/* services */}
          <Route path='/Web-design' element={<Webdesign />} />
          <Route path='/Web-develop' element={<WebDevelopment />} />
          <Route path='/crm-soft' element={<CrmSoftware />} />
          <Route path='/mobile-app' element={<MobileAppDevelopment />} />
          <Route path='/native-app' element={<NativeAppDevelopment />} />
          <Route path='/cross-platform' element={<CrossPlatformSoftware />} />
          <Route path='/ui-ux' element={<UiUxDesign />} />
          <Route path='/software-testing' element={<SoftwareTesting />} />
          <Route path='/secrity-testing' element={<SecurityTesting />} />
          {/* latest  */}
          <Route path='/blockchain' element={<BlockchainDevelopment />} />
          <Route path='/aiml' element={<AiMlDevelopment />} />
          <Route path='/data-analytics' element={<DataAnalytics />} />
           <Route path='/Robotic' element={<RoboticProcessAutomation />} />
          <Route path='/data-science' element={<DataScience />} />
          <Route path='/iot' element={<IoTDevelopment />} />
          <Route path='/cloud' element={<CloudComputing />} />
         <Route path='/digital' element={<DigitalMarketing />} />


        </Routes>
      </BrowserRouter>
      <Footer />
    </div>

  )
}

export default App
